var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-49"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.24,
    y: 65.75,
    width: 71.25,
    height: 241.71,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "153.88 65.75 149.72 65.75 124.87 307.46 129.03 307.46 153.88 65.75",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.78,
    y: 66.68,
    width: 70.45,
    height: 2.13,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.78,
    y: 305.34,
    width: 70.45,
    height: 4.56,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.49,
    y: 309.7,
    width: 66.57,
    height: 0.2,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.49 66.68 162.06 66.68 162.06 309.7 166.05 309.7 166.05 63.69 91.5 63.69 91.5 309.7 95.49 309.7 95.49 66.68",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.53,
    y: 65.75,
    width: 71.25,
    height: 241.71,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.01 65.75 201.3 65.75 176.45 307.46 199.16 307.46 224.01 65.75",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.07,
    y: 66.68,
    width: 72.45,
    height: 2.13,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.07,
    y: 305.34,
    width: 72.45,
    height: 4.56,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.78,
    y: 309.7,
    width: 66.57,
    height: 0.2,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.78 66.68 241.35 66.68 241.35 309.7 245.33 309.7 245.33 63.69 170.79 63.69 170.79 309.7 174.78 309.7 174.78 66.68",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.81,
    y: 65.75,
    width: 69.25,
    height: 241.71,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "291.05 65.75 286.89 65.75 262.04 307.46 266.2 307.46 291.05 65.75",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.36,
    y: 66.68,
    width: 70.45,
    height: 2.13,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.36,
    y: 305.34,
    width: 70.45,
    height: 4.56,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.07,
    y: 309.7,
    width: 66.57,
    height: 0.2,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "254.07 66.68 320.63 66.68 320.63 309.7 324.62 309.7 324.62 63.69 250.08 63.69 250.08 309.7 254.07 309.7 254.07 66.68",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.1,
    y: 65.75,
    width: 71.25,
    height: 241.71,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "395.38 65.75 372.67 65.75 347.81 307.46 370.53 307.46 395.38 65.75",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.64,
    y: 66.68,
    width: 70.45,
    height: 2.13,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.64,
    y: 305.34,
    width: 70.45,
    height: 4.56,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "333.35 66.68 399.92 66.68 399.92 309.7 403.91 309.7 403.91 63.69 329.37 63.69 329.37 309.7 333.35 309.7 333.35 66.68",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.35,
    y: 309.7,
    width: 66.57,
    height: 0.2,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.51,
    y: 251.86,
    width: 30.93,
    height: 53.49,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "141.5 244.38 141.5 257.8 139.07 257.8 124.89 257.8 122.45 257.8 122.45 244.38 141.5 244.38",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.51,
    y: 253.84,
    width: 3.96,
    height: 3.96,
    transform: "translate(286.97 511.64) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.83,
    y: 253.84,
    width: 3.96,
    height: 3.96,
    transform: "translate(271.63 511.64) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.16,
    y: 253.84,
    width: 3.96,
    height: 3.96,
    transform: "translate(256.29 511.64) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.49,
    y: 253.84,
    width: 3.96,
    height: 3.96,
    transform: "translate(240.95 511.64) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.51,
    y: 261.04,
    width: 3.96,
    height: 3.96,
    transform: "translate(286.97 526.03) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.83,
    y: 261.04,
    width: 3.96,
    height: 3.96,
    transform: "translate(271.63 526.03) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.16,
    y: 261.04,
    width: 3.96,
    height: 3.96,
    transform: "translate(256.29 526.03) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.49,
    y: 261.04,
    width: 3.96,
    height: 3.96,
    transform: "translate(240.95 526.03) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.51,
    y: 268.23,
    width: 3.96,
    height: 3.96,
    transform: "translate(286.97 540.42) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.83,
    y: 268.23,
    width: 3.96,
    height: 3.96,
    transform: "translate(271.63 540.42) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.16,
    y: 268.23,
    width: 3.96,
    height: 3.96,
    transform: "translate(256.29 540.42) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.83,
    y: 247.62,
    width: 3.96,
    height: 3.96,
    transform: "translate(271.63 499.2) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.16,
    y: 247.62,
    width: 3.96,
    height: 3.96,
    transform: "translate(256.29 499.2) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.49,
    y: 268.23,
    width: 3.96,
    height: 3.96,
    transform: "translate(240.95 540.42) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.51,
    y: 275.43,
    width: 3.96,
    height: 3.96,
    transform: "translate(286.97 554.82) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.83,
    y: 275.43,
    width: 3.96,
    height: 3.96,
    transform: "translate(271.63 554.82) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.16,
    y: 275.43,
    width: 3.96,
    height: 3.96,
    transform: "translate(256.29 554.82) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.49,
    y: 275.43,
    width: 3.96,
    height: 3.96,
    transform: "translate(240.95 554.82) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.51,
    y: 282.62,
    width: 3.96,
    height: 3.96,
    transform: "translate(286.97 569.21) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.83,
    y: 282.62,
    width: 3.96,
    height: 3.96,
    transform: "translate(271.63 569.21) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.16,
    y: 282.62,
    width: 3.96,
    height: 3.96,
    transform: "translate(256.29 569.21) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.49,
    y: 282.62,
    width: 3.96,
    height: 3.96,
    transform: "translate(240.95 569.21) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.51,
    y: 289.82,
    width: 3.96,
    height: 3.96,
    transform: "translate(286.97 583.6) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.83,
    y: 289.82,
    width: 3.96,
    height: 3.96,
    transform: "translate(271.63 583.6) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.16,
    y: 289.82,
    width: 3.96,
    height: 3.96,
    transform: "translate(256.29 583.6) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.49,
    y: 289.82,
    width: 3.96,
    height: 3.96,
    transform: "translate(240.95 583.6) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.51,
    y: 297.01,
    width: 3.96,
    height: 3.96,
    transform: "translate(286.97 597.99) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.83,
    y: 297.01,
    width: 3.96,
    height: 3.96,
    transform: "translate(271.63 597.99) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.16,
    y: 297.01,
    width: 3.96,
    height: 3.96,
    transform: "translate(256.29 597.99) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.49,
    y: 297.01,
    width: 3.96,
    height: 3.96,
    transform: "translate(240.95 597.99) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.63,
    y: 271.34,
    width: 27.71,
    height: 34,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340.04 275.12 346.48 275.12 348.26 275.12 350.03 275.12 350.03 278.66 348.26 278.66 346.48 278.66 340.04 278.66 340.04 275.12",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340.04 281.99 346.48 281.99 348.26 281.99 350.03 281.99 350.03 285.54 348.26 285.54 346.48 285.54 340.04 285.54 340.04 281.99",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340.04 288.86 346.48 288.86 348.26 288.86 350.03 288.86 350.03 292.41 348.26 292.41 346.48 292.41 340.04 292.41 340.04 288.86",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340.04 295.73 346.48 295.73 349.22 295.73 350.03 295.73 350.03 299.28 349.22 299.28 346.48 299.28 340.04 299.28 340.04 295.73",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "352.93 275.12 359.38 275.12 361.15 275.12 362.92 275.12 362.92 278.66 361.15 278.66 359.38 278.66 352.93 278.66 352.93 275.12",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "352.93 281.99 359.38 281.99 361.88 281.99 362.92 281.99 362.92 285.54 361.88 285.54 359.38 285.54 352.93 285.54 352.93 281.99",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "352.93 288.86 359.38 288.86 361.15 288.86 362.92 288.86 362.92 292.41 361.15 292.41 359.38 292.41 352.93 292.41 352.93 288.86",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "352.93 295.73 359.38 295.73 361.15 295.73 362.92 295.73 362.92 299.28 361.15 299.28 359.38 299.28 352.93 299.28 352.93 295.73",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.63,
    y: 284.22,
    width: 25.18,
    height: 21.13,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.97,
    y: 286.85,
    width: 3.22,
    height: 3.22,
    transform: "translate(457.17 576.93) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.73,
    y: 286.85,
    width: 3.22,
    height: 3.22,
    transform: "translate(444.69 576.93) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.49,
    y: 286.85,
    width: 3.22,
    height: 3.22,
    transform: "translate(432.2 576.93) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.24,
    y: 286.85,
    width: 3.22,
    height: 3.22,
    transform: "translate(419.71 576.93) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.97,
    y: 292.71,
    width: 3.22,
    height: 3.22,
    transform: "translate(457.17 588.64) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.73,
    y: 292.71,
    width: 3.22,
    height: 3.22,
    transform: "translate(444.69 588.64) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.49,
    y: 292.71,
    width: 3.22,
    height: 3.22,
    transform: "translate(432.2 588.64) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.24,
    y: 292.71,
    width: 3.22,
    height: 3.22,
    transform: "translate(419.71 588.64) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.97,
    y: 298.57,
    width: 3.22,
    height: 3.22,
    transform: "translate(457.17 600.36) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.73,
    y: 298.57,
    width: 3.22,
    height: 3.22,
    transform: "translate(444.69 600.36) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.49,
    y: 298.57,
    width: 3.22,
    height: 3.22,
    transform: "translate(432.2 600.36) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.24,
    y: 298.57,
    width: 3.22,
    height: 3.22,
    transform: "translate(419.71 600.36) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.04,
    y: 268.6,
    width: 25.18,
    height: 36.75,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.14,
    y: 270.21,
    width: 9.47,
    height: 9.08,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.65,
    y: 270.21,
    width: 9.47,
    height: 9.08,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.14,
    y: 281.92,
    width: 9.47,
    height: 9.08,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.65,
    y: 281.92,
    width: 9.47,
    height: 9.08,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.14,
    y: 293.63,
    width: 9.47,
    height: 9.08,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.65,
    y: 293.63,
    width: 9.47,
    height: 9.08,
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-49"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-49",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sheet--inject-49"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "444.57 79.61 444.57 299.85 418.07 326.35 264.66 326.35 264.66 79.61 444.57 79.61",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "444.57 79.61 444.57 299.85 418.07 326.35 264.66 326.35 264.66 79.61 444.57 79.61",
    style: {
      fill: "#fff",
      opacity: 0.8,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "418.07 326.35 418.07 300.63 444.57 300.63 418.59 326.61",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.74,101H283.12a2.63,2.63,0,0,1-2.63-2.63h0a2.63,2.63,0,0,1,2.63-2.64h49.62a2.64,2.64,0,0,1,2.63,2.64h0A2.63,2.63,0,0,1,332.74,101Z",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.74,122.34H303.12a2.63,2.63,0,0,1-2.63-2.64h0a2.63,2.63,0,0,1,2.63-2.63H422.74a2.63,2.63,0,0,1,2.63,2.63h0A2.64,2.64,0,0,1,422.74,122.34Z",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.74,132.71H283.12a2.63,2.63,0,0,1-2.63-2.63h0a2.63,2.63,0,0,1,2.63-2.64H422.74a2.64,2.64,0,0,1,2.63,2.64h0A2.63,2.63,0,0,1,422.74,132.71Z",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.74,144.43H283.12a2.63,2.63,0,0,1-2.63-2.64h0a2.63,2.63,0,0,1,2.63-2.63H422.74a2.63,2.63,0,0,1,2.63,2.63h0A2.64,2.64,0,0,1,422.74,144.43Z",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.74,156.14H283.12a2.63,2.63,0,0,1-2.63-2.63h0a2.63,2.63,0,0,1,2.63-2.63H422.74a2.63,2.63,0,0,1,2.63,2.63h0A2.63,2.63,0,0,1,422.74,156.14Z",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.74,167.86H283.12a2.63,2.63,0,0,1-2.63-2.63h0a2.62,2.62,0,0,1,2.63-2.63H422.74a2.63,2.63,0,0,1,2.63,2.63h0A2.63,2.63,0,0,1,422.74,167.86Z",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.74,179.58H283.12a2.63,2.63,0,0,1-2.63-2.63h0a2.63,2.63,0,0,1,2.63-2.64H422.74a2.64,2.64,0,0,1,2.63,2.64h0A2.63,2.63,0,0,1,422.74,179.58Z",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.49,
    y: 186.03,
    width: 144.89,
    height: 5.27,
    rx: 2.63,
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.74,203H283.12a2.63,2.63,0,0,1-2.63-2.63h0a2.63,2.63,0,0,1,2.63-2.63H422.74a2.63,2.63,0,0,1,2.63,2.63h0A2.63,2.63,0,0,1,422.74,203Z",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.74,214.73H283.12a2.63,2.63,0,0,1-2.63-2.63h0a2.62,2.62,0,0,1,2.63-2.63H422.74a2.63,2.63,0,0,1,2.63,2.63h0A2.63,2.63,0,0,1,422.74,214.73Z",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.74,226.45H283.12a2.63,2.63,0,0,1-2.63-2.63h0a2.63,2.63,0,0,1,2.63-2.64H422.74a2.64,2.64,0,0,1,2.63,2.64h0A2.63,2.63,0,0,1,422.74,226.45Z",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.74,238.17H283.12a2.63,2.63,0,0,1-2.63-2.64h0a2.63,2.63,0,0,1,2.63-2.63H422.74a2.63,2.63,0,0,1,2.63,2.63h0A2.64,2.64,0,0,1,422.74,238.17Z",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.74,249.88H283.12a2.63,2.63,0,0,1-2.63-2.63h0a2.63,2.63,0,0,1,2.63-2.63h59.62a2.63,2.63,0,0,1,2.63,2.63h0A2.63,2.63,0,0,1,342.74,249.88Z",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412,133.58l-.19-.16c-.54-.41-.85-.27-1.1-1.06-.18-.57,0-1.21-.21-1.8a24.89,24.89,0,0,0-1.63-2.94l-2.46-4.43a4.25,4.25,0,0,0-5.77-1.64l-22.65,12.62c-.09.76-.72,1.28-.85,2a1.25,1.25,0,0,0,.38,1.18,1.17,1.17,0,0,1-.7-.25c-1.35-.75-1.71-1.35-3.1-.59-.6.32-1.19.66-1.78,1l-6,3.35-18.8,10.47-22,12.28-18.33,10.21c-2.5,1.39-5.53,2.61-7.76,4.38.62.32.73.81.18,1.29l-1,.91c0,.25.36.25.59.15l1.24-.53a12.55,12.55,0,0,1-3.07,2.79,25,25,0,0,1-6.28,2.58l1.06-1.33c.08-.11.18-.25.11-.38s-.2-.14-.32-.15c-.53-.06-1.06,0-1.45-.39-3.42,2-7,3.9-10.48,5.84a4.25,4.25,0,0,0-1.64,5.77l22.84,41a4.23,4.23,0,0,0,5.76,1.64L312.6,234c0-.71.56-1.5.14-2.15a.57.57,0,0,1-.11-.27c0-.13.12-.23.23-.3a4.28,4.28,0,0,1,2.05-.66c.25,0,.58.11.54.35,0-.22,1.29-.68,1.5-.75.1.54-.27,1.12.36,1.23s1.59-1,2-1.2l6-3.35,19-10.57,20.84-11.61L379,197c.5-.29,1.09-.63,1.57-.87a4.64,4.64,0,0,1,1.28-2.42c1-.69,2.58.07,3.41-.91.16-.19.26-.42.4-.62a3.33,3.33,0,0,1,1-.79,1.57,1.57,0,0,1,.84-.33c.3,0,.62.25.58.55,2.06-.48,3.92-1.87,5.74-2.9.66-.37,6.45-3.09,6.43-3.52-.08-1.33.73-2.47.69-3.84,0-.26-.51-2-.28-2.13-5.2,3.1-10.6,5.92-15.9,8.86-.18.11-.86.34-1,.54,0,0-.05.09-.07.14l-.15.33,0,.08a18.83,18.83,0,0,1-.76,2c0,.09-1.13,1.49-1.22,1.16-.44-1.61-1-1.86-2.23-1.2l-1.76,1-5.59,3.11-18.83,10.5-22.19,12.36-18.49,10.3-7.75,4.31q-2.32-4.2-4.67-8.39l-3-5.39a6.11,6.11,0,0,0-1.32-2c-.43-.32-1.16-.24-1.54-.53-.93-.71-1.6-2-2.48-2.83-.6-.56-1.51-2.24-1.26-3.17.3.12.6.25.9.34a3.12,3.12,0,0,1,.1-1.86c-3-5.05-5.76-10.33-8.63-15.49l-.19-.33,7-3.9,5.11-2.85a17.7,17.7,0,0,0,3-1.65c.65-.56,1.31-1.26,2-1.86a7.28,7.28,0,0,1,1.5-.88l1.89-.92a.71.71,0,0,1,.32-.1,1.32,1.32,0,0,1,.33.08c1,.21,3.48-1.64,4.38-2.14l5.82-3.24,17.56-9.79,21.88-12.18,21.9-12.21,17.62-9.81,9-5,.42-.23,9.73,17.47a6.18,6.18,0,0,0,2.75,2.72c.4.13.85.41.8.82s-.65.75-.51,1.17.91.26,1.09.64-.31,1-.25,1.52a6,6,0,0,0,.91,1.73l2.83,5.09c1.58,2.82,3.15,5.65,4.74,8.5l-17.3,9.64a.85.85,0,0,1,.21.25l.09.23a7.37,7.37,0,0,1,1,.44.86.86,0,0,1,.44.78.88.88,0,0,1-.46.76l-1.06.6a1.16,1.16,0,0,1-.91.95,2.22,2.22,0,0,1-.37,0,.9.9,0,0,1-.74.15.92.92,0,0,1-.62-1.11,1.35,1.35,0,0,1,.16-.29.9.9,0,0,1,.06-.93l-.32,0c-.18,0-.34-.1-.51-.15a5,5,0,0,0-2,2.36.27.27,0,0,0-.06.19c0,.14.22.15.35.21.3.14.23.58.08.87s-.33.66-.13.92a1.88,1.88,0,0,0,.25.24c.43.49-.23,1.91.82,1.33a1.25,1.25,0,0,1,.13-.91,1.34,1.34,0,0,1,.77-.57,12.54,12.54,0,0,1,2.37-.34L427.55,170a4.25,4.25,0,0,0,1.64-5.77l-.12-.21-9.42-16.91-5.44-9.78c-.53-.93-1-1.9-1.58-2.82A3.56,3.56,0,0,0,412,133.58Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.66,188.83c-.69-.84-.48-.86-.61-1.76,0,0,0,0,0-.06l-.08-.09-.12-.14c-.47.21-.94.44-1.41.7l-9.21,5.13,3.71,6.65c-.52-.92,1.32-.65,1.39-.66a2.51,2.51,0,0,1,.6-.1.79.79,0,0,1,.49.33,3.05,3.05,0,0,1,.32,2.22c-.11,1,.42,2-.15,3,.49.8,4.92,8.86,4.94,8.85l9.21-5.13c.53-.3,1.79-.83,2.1-1.36s-.18-1.36.37-1.61a1.48,1.48,0,0,1,1.27.12,11.14,11.14,0,0,0,1.79-13.52c-2.59-4.65-8.47-7.42-13.62-5.26-.36.15.12,1.76-.74,1.94a2.37,2.37,0,0,1,.69-.82M322.34,204l-4.29,2.39c-.35-.63-.69-1.26-1.05-1.87.45.76-.79.52-1.05.35-.63-.42-.8-1.63-.82-2.31a6.14,6.14,0,0,0-1-3.28q-1.51-2.73-3-5.46l4.29-2.39c4-2.24,8-1.31,10.16,2.57S326.37,201.79,322.34,204Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.11,171.8a2.48,2.48,0,0,1,.18,1.52c-.05.28-.5,1-.44,1.18.16.4.32.8.47,1.2a.67.67,0,0,0,.11.18.47.47,0,0,0,.26.08c1.59.14,1.52.3,1.62,1.64.09,1.15,1.08,1.81,1.64,2.81a7.33,7.33,0,0,1-9,10.48,1.06,1.06,0,0,1-.12.1,1,1,0,0,1-.68.08,3,3,0,0,1-2.11-2.23.65.65,0,0,1,0-.24,7.54,7.54,0,0,1-.75-1.12,7.07,7.07,0,0,1,2.73-10,7.29,7.29,0,0,1,4.12-.94l-.08-.12c-.86-1.14,2.24-1.6.84-2.37-.59-.32-.49-1.77-.64-2.36a13.71,13.71,0,0,0-6.47,1.79c-6.4,3.57-8.61,10.64-5.25,16.67a11.76,11.76,0,0,0,6.55,5.51,5.84,5.84,0,0,0,2.08.48c.82-.07.42,0,.77-.49s.14-.7.67-1.22,1.15-.83,1.26-1.63c0,.36.4.62.4,1,0,.11,0,.22,0,.32a.68.68,0,0,0,.17.35c.34.46.91,1,.92,1.53a11.83,11.83,0,0,0,4.14-1.52c6.37-3.55,8.63-10.61,5.25-16.66C353,174.73,349.71,172,346.11,171.8Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.56,157.88l6.86,12.31-16.94-6.7-3.88,2.17c2.62,4.7,5.4,9.35,7.86,14.14.17-.52.57-.62,1.05-.69.9-.12.87.33,1.36,1.22.06.11.13.22.24.24s.33-.16.51-.14.25.24.2.41a2.12,2.12,0,0,1-.25.47c-.29.55.19.9.13,1.4,0,.26-.87,1.32-.77,1.5l1,1.72,4.64-2.58-1.24-2.22-.23,0c-1.35.18-.75-1.59-1.05-2.32a26.84,26.84,0,0,0-1.65-3L361.67,171l13.77,5.42a2.84,2.84,0,0,1,.14-1.17c.11-.21,1-.6,1-.8a2.48,2.48,0,0,0,.84,1.67c.53.47.53.4.43,1.23l.82.33,3.86-2.15-11.3-20.27Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.87,166.53l-2.62-4.69,9.42-5.25-2-3.65-9.41,5.25-2.45-4.41,6.36-3.54a3,3,0,0,1,1-.83.9.9,0,0,1,.64-.07l2.69-1.49s-1.91-3.41-2.09-3.77c-.92.42,0,1.58-.93,2.14.19.2.47.91,0,1-.27,0-.47-.34-.74-.31s-.28.16-.42.12a.29.29,0,0,1-.19-.17,4.18,4.18,0,0,0-.49-.85c-.63-.61-6.38,3.22-7.18,3.67l-5.35,3,11.29,20.27,4.51-2.51.09-.12c.33-.42.65-.85,1-1.24a.91.91,0,0,1,1.08-.13.68.68,0,0,1,.21.17l8.81-4.91-2.1-3.77Z",
    style: {
      fill: "#407BFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M401.9,382.21s-6.58-14.34.93-28.49,9.7-17.48,4.91-20.37-7,11.31-7,11.31-4-9.78-.71-20,5.43-26.9.88-28.69-.87,20.79-4.82,28.49a66.37,66.37,0,0,1-3.87-16.79c-.54-8.22.31-21.34-3.29-24.71s-5.89-1-2.36,17.1a190.39,190.39,0,0,1,3.51,32.89s-7.81-23.8-13-24.49-5.23,7-.74,13.69S389.43,340.8,390.84,347c0,0-8.56-17.9-16.27-12.42s6.71,16.31,13.13,20.22,10.89,28.4,10.89,28.4Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.9,382.21s-6.58-14.34.93-28.49,9.7-17.48,4.91-20.37-7,11.31-7,11.31-4-9.78-.71-20,5.43-26.9.88-28.69-.87,20.79-4.82,28.49a66.37,66.37,0,0,1-3.87-16.79c-.54-8.22.31-21.34-3.29-24.71s-5.89-1-2.36,17.1a190.39,190.39,0,0,1,3.51,32.89s-7.81-23.8-13-24.49-5.23,7-.74,13.69S389.43,340.8,390.84,347c0,0-8.56-17.9-16.27-12.42s6.71,16.31,13.13,20.22,10.89,28.4,10.89,28.4Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.7,388.1s6.41-14.45-1.27-28.48-9.91-17.33-5.15-20.3,7.12,11.21,7.12,11.21,3.92-9.83.47-20-5.75-26.82-1.22-28.67,1.12,20.78,5.16,28.41a66,66,0,0,0,3.66-16.84c.45-8.23-.56-21.34,3-24.76s5.89-1.12,2.57,17.07a190.36,190.36,0,0,0-3.11,32.93s7.52-23.91,12.75-24.68,5.31,6.93.91,13.68-12.9,18.85-14.25,25c0,0,8.35-18,16.12-12.65s-6.51,16.4-12.88,20.4S400,389,400,389Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "426.24 377.8 373.34 377.8 377.62 415.66 421.96 415.66 426.24 377.8",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.63,139.75H120.72a5.07,5.07,0,0,0-5.07,5.07v33.94a5.07,5.07,0,0,0,5.07,5.07h11.17l-7.52,10.22,13-10.22h18.25a5.07,5.07,0,0,0,5.07-5.07V144.82A5.07,5.07,0,0,0,155.63,139.75Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.63,139.75H120.72a5.07,5.07,0,0,0-5.07,5.07v33.94a5.07,5.07,0,0,0,5.07,5.07h11.17l-7.52,10.22,13-10.22h18.25a5.07,5.07,0,0,0,5.07-5.07V144.82A5.07,5.07,0,0,0,155.63,139.75Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.18,
    cy: 161.79,
    r: 15.85,
    style: {
      fill: "#407BFF",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.18,
    cy: 161.79,
    r: 13.59,
    transform: "translate(-51.03 259.1) rotate(-76.72)",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.49,168.28a1.4,1.4,0,0,1-1-.39l-5.77-5.65a1.39,1.39,0,0,1,1.94-2l4.73,4.63,8.18-9.13a1.39,1.39,0,0,1,2.07,1.85l-9.15,10.21a1.38,1.38,0,0,1-1,.46Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.9,392.92l28.81-2.84V357.59h11.42v32.48l28.93,2.85a5.6,5.6,0,0,1,5.06,5.58v4.33H87.84V398.5A5.6,5.6,0,0,1,92.9,392.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9,392.92l28.81-2.84V357.59h11.42v32.48l28.93,2.85a5.6,5.6,0,0,1,5.06,5.58v4.33H87.84V398.5A5.6,5.6,0,0,1,92.9,392.92Z",
    style: {
      fill: "#fff",
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164.07,
    cy: 408.19,
    r: 7.47,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.89,
    cy: 408.19,
    r: 7.47,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.88,330.23H131a4.13,4.13,0,0,1,4.13,4.13V366.3a0,0,0,0,1,0,0H119.75a0,0,0,0,1,0,0V334.36A4.13,4.13,0,0,1,123.88,330.23Z",
    transform: "translate(254.84 696.52) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.88,330.23H131a4.13,4.13,0,0,1,4.13,4.13V366.3a0,0,0,0,1,0,0H119.75a0,0,0,0,1,0,0V334.36A4.13,4.13,0,0,1,123.88,330.23Z",
    transform: "translate(254.84 696.52) rotate(180)",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.54,267.62S96.1,321,113,330.23H95.82s-17-18.2-22.12-62.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.54,267.62S96.1,321,113,330.23H95.82s-17-18.2-22.12-62.61Z",
    style: {
      fill: "#fff",
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95,322.68h66.92a5,5,0,0,1,5,5v6.69a0,0,0,0,1,0,0H90a0,0,0,0,1,0,0v-6.69A5,5,0,0,1,95,322.68Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.76,
    y: 328.52,
    width: 83.33,
    height: 5.84,
    rx: 2.01,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.76,
    y: 328.52,
    width: 83.33,
    height: 5.84,
    rx: 2.01,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.67,278.48H99.16c8.06,0,13.29-6.46,11.69-14.43l-2.14-10.64c-1.6-8-9.43-14.42-17.48-14.42H63.74c-8.06,0-13.29,6.46-11.69,14.42l2.14,10.64C55.79,272,63.61,278.48,71.67,278.48Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "217.54 367.89 211.24 370.36 206.71 361.82 202.59 354.05 209.57 349.87 213.79 359.4 217.54 367.89",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "213.79 359.4 206.71 361.82 202.59 354.05 209.57 349.87 213.79 359.4",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.48,354.74l-8.57,4.6s-32.39-56.95-37.37-56.47-52.23,30.58-66.64,19.46-.39-44.6-.39-44.6,29.81-8.52,33-2a49.75,49.75,0,0,1,2.14,6c.63,2.05,1.11,3.78,1.11,3.78h0c.91-.37,30.35-12.44,43.49-6C192.66,286.13,212.48,354.74,212.48,354.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.48,354.74l-8.57,4.6s-32.39-56.95-37.37-56.47-52.23,30.58-66.64,19.46-.39-44.6-.39-44.6,29.81-8.52,33-2a49.75,49.75,0,0,1,2.14,6c.63,2.05,1.11,3.78,1.11,3.78h0c.91-.37,30.35-12.44,43.49-6C192.66,286.13,212.48,354.74,212.48,354.74Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165.92 401.18 159.2 400.41 159.16 390.93 159.15 382.23 167.28 381.85 166.56 392.08 165.92 401.18",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "166.54 392.29 159.14 391.11 159.14 382.32 167.27 381.89 166.54 392.29",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.72 356.51 212.26 350.23 213.57 355.55 204.07 360.45 199.72 356.51",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.16,322.42s2.06-.23,33.75-6.1c0,0,.72,40.52,2.22,70.73l9.76.31s14-67,12.35-77.16-13.69-11.49-13.69-11.49S145.64,315,122.16,322.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.16,322.42s2.06-.23,33.75-6.1c0,0,.72,40.52,2.22,70.73l9.76.31s14-67,12.35-77.16-13.69-11.49-13.69-11.49S145.64,315,122.16,322.42Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.16,322.42s2.06-.23,33.75-6.1c0,0,.72,40.52,2.22,70.73l9.76.31s14-67,12.35-77.16-13.69-11.49-13.69-11.49S145.64,315,122.16,322.42Z",
    style: {
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "156.34 384.35 169.65 384.04 167.83 389.52 157.03 389.62 156.34 384.35",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.8,285.53l-17.27,6.15s9.08-6.78,16.16-9.93C135.32,283.8,135.8,285.53,135.8,285.53Z",
    style: {
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.51 275.67 98.15 280.46 130.52 273.59 129.77 267.93 97.51 275.67",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.51 275.67 98.15 280.46 130.52 273.59 129.77 267.93 97.51 275.67",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.36,
    y: 272.27,
    width: 1.64,
    height: 8.35,
    transform: "translate(-48.6 24.37) rotate(-10.51)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.81,
    y: 270.83,
    width: 7.24,
    height: 5.49,
    transform: "translate(-57.23 32.96) rotate(-12.7)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.05,
    y: 267.42,
    width: 1.64,
    height: 8.35,
    transform: "matrix(0.98, -0.18, 0.18, 0.98, -47.36, 27.86)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.36,
    y: 272.27,
    width: 1.64,
    height: 8.35,
    transform: "translate(-48.6 24.37) rotate(-10.51)",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.05,
    y: 267.42,
    width: 1.64,
    height: 8.35,
    transform: "matrix(0.98, -0.18, 0.18, 0.98, -47.36, 27.86)",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.06,379.07a8.92,8.92,0,0,0-3.25-.37h0s-4.07-1.7-9-9.79l-4.2.55a3.49,3.49,0,0,0-2.9,2.75,2,2,0,0,0,0,.6,23.58,23.58,0,0,0,.74,3,85,85,0,0,0,3.81,9.53l.68-.28L213.77,379c-.72-2.07,1.79-.32,3.12,1.68s3.22,3.94,7.71,2.24C229.82,380.88,231.89,379.8,230.06,379.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.76,366.76S223.5,377,226.81,378.7c0,0-3.71,3-8.66-1.82-6.39-6.19-7.46-4.07-7.46-4.07a19.41,19.41,0,0,1,.17-3.63C211.37,366.83,216.76,366.76,216.76,366.76Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176,413.1A9.09,9.09,0,0,0,172.9,412h0s-3.55-2.61-6.4-11.63l-4.21-.46a3.46,3.46,0,0,0-3.47,2,1.9,1.9,0,0,0-.18.57,22.47,22.47,0,0,0,0,3.07,83.52,83.52,0,0,0,1.44,10.16l.73-.11-.65-6.42c-.21-2.18,1.82.12,2.64,2.38s2.19,4.59,6.95,4C175.31,414.81,177.57,414.25,176,413.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,398s4.12,11.55,6.93,14c0,0-4.31,2-8-3.82-4.75-7.53-6.28-5.72-6.28-5.72a19.32,19.32,0,0,1,1-3.48C160.71,396.78,166,398,166,398Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.46,194,82,195.7a2.8,2.8,0,0,1-2.42.59c-2.52-1-6.15-3.93-6.61-5-.68-1.51,0-5.94,1.78-6.74s7.91,6.6,7.91,6.6l9.09-2.05Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.14,222.12s-.77-27.41-3.94-28.58-27,2.1-27,2.1l-.58-6.26s27.73-4.27,33.1-1.74,7.14,43.38,6.16,51.25Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.14,222.12s-.77-27.41-3.94-28.58-27,2.1-27,2.1l-.58-6.26s27.73-4.27,33.1-1.74,7.14,43.38,6.16,51.25Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.61 196.24 84.95 189.36 87.33 188.5 88.84 196.45 86.61 196.24",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.61 196.24 84.95 189.36 87.33 188.5 88.84 196.45 86.61 196.24",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117,218.7s-2.13,8.34-12.39,11S83,225.41,83,225.41l2.26,19.9,12.56,31.35,32.1-8.37S128,231.82,117,218.7Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117,218.7s-2.13,8.34-12.39,11S83,225.41,83,225.41l2.26,19.9,12.56,31.35,32.1-8.37S128,231.82,117,218.7Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.34,
    y: 242.35,
    width: 5.52,
    height: 9.02,
    rx: 0.79,
    transform: "translate(314.77 445.26) rotate(162.49)",
    style: {
      fill: "#407BFF",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.79,
    y: 242.93,
    width: 4.48,
    height: 6.13,
    transform: "translate(314.37 443.59) rotate(162.49)",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.23,
    y: 240.38,
    width: 0.99,
    height: 3.61,
    transform: "translate(-67.21 47.83) rotate(-17.51)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.18,187.55c-7.91,0-13.13,8.38-11.28,21.67s9.26,17.12,9.26,17.12l-.47-3.21a75.4,75.4,0,0,0,25.09,1.4s-3.82-10.84-2.58-21.91C115.2,202.62,117.71,187.53,95.18,187.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.89,227l3.23,12-5.68-4.33s5.53,12.64,7,20c0,0-4.78-12.53-8.9-19.4l-2.41,6.88-9.69-9.87S103,225.72,110.89,227Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.17,230.87l-9.86.3c4.37-5.59-3.53-15.33-3.53-15.33l9.74,2.11c2.32,9.64,6.33,9.93,6.33,9.93Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.24,224.87A14.78,14.78,0,0,1,95.46,220a29.72,29.72,0,0,0-2.68-4.12l9.74,2.12A22.16,22.16,0,0,0,105.24,224.87Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.51,191.62c8.49.71,10.85,5.48,10.74,14.29-.13,11-3.21,18.57-13.63,15.35C85.46,216.89,88.4,190.44,102.51,191.62Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.8,205a18.07,18.07,0,0,0,2.18,3.73,2.36,2.36,0,0,1-2.32.77Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.05,203.58l1.84-.6S102.91,204.44,102.05,203.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.69,203.37a1.57,1.57,0,0,0-2,.54,2.41,2.41,0,0,1,2,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.27,199.32a.36.36,0,0,1-.25-.11.35.35,0,0,1,0-.51,4.78,4.78,0,0,1,4.13-1.08.36.36,0,1,1-.15.71,4.12,4.12,0,0,0-3.46.87A.35.35,0,0,1,99.27,199.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.59,199.47a.34.34,0,0,1-.22-.07,3.65,3.65,0,0,0-3-.92.36.36,0,0,1-.19-.7,4.32,4.32,0,0,1,3.65,1.05.37.37,0,0,1,.06.51A.36.36,0,0,1,112.59,199.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92,205.16s4.55-6.64,4.4-12.08c0,0,17.41-5.48,16.82,11.68,0,0,2.9-15-11.67-16.59S85.29,208,92.3,215C92.3,215,89.21,209.32,92,205.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.27,207.07a3.74,3.74,0,0,0-3.73-3.74c-2.66.07-4.36,5.37,2.08,7.22C92.54,210.81,93.15,209.94,93.27,207.07Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.73,212a20.59,20.59,0,0,0-1.67,2.64c-.17-.06-.35-.11-.52-.18-2.35-.83-3.17-2-3.36-3a3.12,3.12,0,0,1,.11-1.52,3.25,3.25,0,0,1,.36-.8,11.58,11.58,0,0,0,4.28,2.58C107.41,211.9,107.73,212,107.73,212Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.93,211.7l-.51.77c-2.22-.79-3.67-1.64-4.13-2.55a3.25,3.25,0,0,1,.36-.8A11.58,11.58,0,0,0,106.93,211.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.54,214.46c-2.35-.83-3.17-2-3.36-3a7.92,7.92,0,0,1,2.43,1.43A3,3,0,0,1,105.54,214.46Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.28,192.25S97.69,205.94,88.91,205s6.27-17.48,6.27-17.48,14.81-4.23,21.26,4-3.19,13.22-3.19,13.22S114.69,194,102.28,192.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.28,203.9a.28.28,0,0,1-.24-.16.26.26,0,0,1,.15-.33c7-2.67,6.84-12.06,6.84-12.16a.23.23,0,0,1,.24-.25.27.27,0,0,1,.26.24c0,.1.16,9.84-7.16,12.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.67,204.41l1.84-.59S111.52,205.27,110.67,204.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.31,204.2a1.56,1.56,0,0,0-2,.55,2.39,2.39,0,0,1,2-.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.7 227.13 105.13 230.91 105.01 238.44 94.39 232.25 97.7 227.13",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.26 225.71 106.7 230.28 111.55 235.41 110.89 226.97 106.26 225.71",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.93,174l-3.1-8a2.78,2.78,0,0,0-.81-2.35c-2.16-1.61-6.62-3.07-7.74-2.9-1.63.24-5,3.19-4.71,5.12s9.81,3.12,9.81,3.12l3.16,8.77Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.28,245.31s6-4.77,3.61-15.31l-6.45-29.16L71.36,170.72l-5.42,2.74s9.1,29.43,9.94,31.42c.43,1,2.14,16.27,4.47,26.5C82.49,240.8,85.28,245.31,85.28,245.31Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.28,245.31s6-4.77,3.61-15.31l-6.45-29.16L71.36,170.72l-5.42,2.74s9.1,29.43,9.94,31.42c.43,1,2.14,16.27,4.47,26.5C82.49,240.8,85.28,245.31,85.28,245.31Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "64.99 172.6 71.32 169.43 72.7 171.54 65.3 174.82 64.99 172.6",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "64.99 172.6 71.32 169.43 72.7 171.54 65.3 174.82 64.99 172.6",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.7 227.13 105.13 230.91 105.01 238.44 94.39 232.25 97.7 227.13",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.26 225.71 106.7 230.28 111.55 235.41 110.89 226.97 106.26 225.71",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-49"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 287.3,
    y: 211.41,
    width: 29.96,
    height: 23.28,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.58,
    y: 211.41,
    width: 7.68,
    height: 23.28,
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "285.58 255.25 319.45 255.25 319.45 213 308.54 213 285.58 223.99 285.58 255.25",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.54,
    y: 213,
    width: 10.91,
    height: 42.25,
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.07,
    y: 232.32,
    width: 15.86,
    height: 7.6,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.07,
    y: 242.46,
    width: 15.86,
    height: 1.09,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.58,
    y: 245.65,
    width: 8.81,
    height: 6.45,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.57,
    y: 210.14,
    width: 29.96,
    height: 24.55,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.85,
    y: 210.14,
    width: 7.68,
    height: 24.55,
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "272.85 255.25 306.72 255.25 306.72 213 295.81 213 272.85 223.99 272.85 255.25",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.81,
    y: 213,
    width: 10.91,
    height: 42.25,
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.34,
    y: 232.32,
    width: 15.86,
    height: 7.6,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.34,
    y: 242.46,
    width: 15.86,
    height: 1.09,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.85,
    y: 245.65,
    width: 8.81,
    height: 6.45,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "251.81 415.66 257.94 415.66 268.94 262.41 260.81 262.41 251.81 415.66",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "251.81 415.66 257.94 415.66 268.4 270.02 268.94 262.66 260.81 262.66 260.38 270.02 251.81 415.66",
    style: {
      fill: "#fff",
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "260.38 269.66 268.4 269.66 268.94 262.66 260.81 262.66 260.38 269.66",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.85 415.66 212.98 415.66 213.98 262.41 205.85 262.41 206.85 415.66",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.84 262.66 206.01 287.38 206.84 415.66 212.97 415.66 213.81 287.38 213.97 262.66 205.84 262.66",
    style: {
      fill: "#fff",
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.84 262.66 206.01 287.66 213.81 287.66 213.97 262.66 205.84 262.66",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "141.81 415.66 147.94 415.66 158.94 262.41 150.81 262.41 141.81 415.66",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "141.81 415.66 147.94 415.66 158.41 270.02 158.94 262.66 150.81 262.66 150.38 270.02 141.81 415.66",
    style: {
      fill: "#fff",
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "150.38 269.66 158.41 269.66 158.94 262.66 150.81 262.66 150.38 269.66",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "321.89 415.66 328.02 415.66 319.01 262.41 310.88 262.41 321.89 415.66",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "310.88 262.66 311.43 270.02 321.89 415.66 328.01 415.66 319.45 270.02 319.01 262.66 310.88 262.66",
    style: {
      fill: "#fff",
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "319.01 262.66 310.88 262.66 311.43 269.66 319.45 269.66 319.01 262.66",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.53,258.57H323.29a2.16,2.16,0,0,1,2.16,2.16v5.51a0,0,0,0,1,0,0H144.37a0,0,0,0,1,0,0v-5.51A2.16,2.16,0,0,1,146.53,258.57Z",
    transform: "translate(469.83 524.82) rotate(180)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.53,258.57H323.29a2.16,2.16,0,0,1,2.16,2.16v5.51a0,0,0,0,1,0,0H144.37a0,0,0,0,1,0,0v-5.51A2.16,2.16,0,0,1,146.53,258.57Z",
    transform: "translate(469.83 524.82) rotate(180)",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.37,
    y: 258.57,
    width: 181.08,
    height: 3.84,
    transform: "translate(469.83 520.98) rotate(180)",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.58,259.57H329.25a2.15,2.15,0,0,0,2.16-2.16h0a2.16,2.16,0,0,0-2.16-2.16H140.58a2.17,2.17,0,0,0-2.17,2.16h0A2.16,2.16,0,0,0,140.58,259.57Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.58,259.57H329.25a2.15,2.15,0,0,0,2.16-2.16h0a2.16,2.16,0,0,0-2.16-2.16H140.58a2.17,2.17,0,0,0-2.17,2.16h0A2.16,2.16,0,0,0,140.58,259.57Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "288.71 255.23 288.71 251.85 290.98 251.85 288.71 250.53 290.41 250.53 288.14 249.05 285.99 249.05 285.99 247.35 288.49 247.35 285.99 246.36 285.99 242.67 288.49 242.67 288.49 240.26 290.98 240.26 288.49 239.42 288.49 237.7 290.27 237.7 288.81 236.25 287.55 234.98 248.91 234.98 248.91 236.71 246.36 236.71 249.2 237.99 249.2 239.42 243.99 239.42 243.99 242.08 241.68 242.08 243.99 243.24 243.99 246.21 245.63 246.21 245.63 247.63 248.91 247.63 248.91 251.85 247.07 251.85 248.58 253.36 248.58 255.25 288.71 255.23",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "288.71 255.23 288.71 251.85 290.98 251.85 288.71 250.53 290.41 250.53 288.14 249.05 285.99 249.05 285.99 247.35 288.49 247.35 285.99 246.36 285.99 242.67 288.49 242.67 288.49 240.26 290.98 240.26 288.49 239.42 288.49 237.7 290.27 237.7 288.81 236.25 287.55 234.98 248.91 234.98 248.91 236.71 246.36 236.71 249.2 237.99 249.2 239.42 243.99 239.42 243.99 242.08 241.68 242.08 243.99 243.24 243.99 246.21 245.63 246.21 245.63 247.63 248.91 247.63 248.91 251.85 247.07 251.85 248.58 253.36 248.58 255.25 288.71 255.23",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "288.71 255.23 288.71 251.85 290.98 251.85 288.71 250.53 290.41 250.53 288.14 249.05 285.99 249.05 285.99 247.35 288.49 247.35 285.99 246.36 285.99 242.67 288.49 242.67 288.49 240.26 290.98 240.26 288.49 239.42 288.49 237.7 290.27 237.7 288.81 236.25 287.55 234.98 267.2 234.98 267.2 236.71 264.65 236.71 267.48 237.99 267.48 239.42 262.27 239.42 262.27 242.08 259.96 242.08 262.27 243.24 262.27 246.21 263.91 246.21 263.91 247.63 267.2 247.63 267.2 251.85 265.36 251.85 266.86 253.36 266.86 255.25 288.71 255.23",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "249.2 239.42 267.48 239.42 249.2 238.76 249.2 239.42",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "248.91 247.63 267.2 247.63 267.28 248.91 248.91 247.63",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "245.63 246.21 263.91 246.21 245.63 246.85 245.63 246.21",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "248.91 251.85 267.2 251.85 248.91 251.18 248.91 251.85",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "248.58 253.36 266.86 253.36 266.86 254.06 248.58 253.36",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "243.99 242.08 262.27 242.08 243.99 241.5 243.99 242.08",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "248.91 236.71 267.2 236.71 248.91 236.07 248.91 236.71",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "288.49 237.7 269.94 237.7 288.49 238.27 288.49 237.7",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "267.48 239.42 288.49 239.42 269.44 240.04 267.48 239.42",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "262.27 242.08 288.49 242.67 288.49 242.08 262.27 242.08",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "262.27 243.24 275.24 243.24 262.27 243.87 262.27 243.24",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "285.99 246.36 267.2 246.21 285.99 245.79 285.99 246.36",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "285.99 247.35 266.86 247.35 285.99 247.99 285.99 247.35",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "288.71 250.53 267.48 250.53 267.48 251.18 288.71 250.53",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "288.71 251.85 273.33 251.85 288.71 252.28 288.71 251.85",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.51,250.87v3.21c0,.82-1,1.16-1.79,1.16H173.6c-.82,0-1.81-.34-1.81-1.16v-3.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.51,250.87v3.21c0,.82-1,1.16-1.79,1.16H173.6c-.82,0-1.81-.34-1.81-1.16v-3.21Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.51,250.87v3.21c0,.82-1,1.16-1.79,1.16H195.43c-.82,0-1.8-.34-1.8-1.16v-3.21Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.24,217.55l-7.64,34.63a2.59,2.59,0,0,1-2.48,2H198.43a1.68,1.68,0,0,1-1.57-2.17l7.62-34.36a2.39,2.39,0,0,1,2.48-1.7h41.7C249.78,215.91,250.48,216.42,250.24,217.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.24,217.55l-7.64,34.63a2.59,2.59,0,0,1-2.48,2H199.84a1.68,1.68,0,0,1-1.57-2.17l7.63-34.36a2.38,2.38,0,0,1,2.48-1.7h40.28C249.78,215.91,250.48,216.42,250.24,217.55Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.68,235.15h0c0,3-3.18,5.37-5.51,5.37s-3.71-2.41-3-5.37,3-5.27,5.26-5.36c-.66,3,.76,5.36,3.08,5.36Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.314a298e6775b9f36f5c5db5bd5035e7.svg";
export { ForwardRef as ReactComponent };